import { useState } from "react";

const categories = [
  "All Project",
  "Nature",
  "People",
  "Art",
  "Creative",
  "Poster",
  "Other",
];

const portfolio = [
  {
    id: 1,
    title: "Portrait Session",
    category: "People",
    image: "https://placehold.co/700x850",
  },
  {
    id: 2,
    title: "Creative Design",
    category: "Creative",
    image: "https://placehold.co/700x850",
  },
  {
    id: 3,
    title: "Nature Shot",
    category: "Nature",
    image: "https://placehold.co/700x850",
  },
];

export default function Portfolio() {
  const [active, setActive] = useState("All Project");

  return (
    <section
      id="portfolio"
      className="py-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}

        <div className="relative mb-20 text-center">

          <h2 className="absolute left-1/2 -translate-x-1/2 -top-10 text-[90px] lg:text-[160px] font-black text-gray-100 uppercase select-none">
            Portfolio
          </h2>

          <div className="relative flex flex-wrap justify-center gap-8 uppercase tracking-wider text-sm">

            {categories.map((item) => (
              <button
                key={item}
                onClick={() => setActive(item)}
                className={`transition font-medium ${
                  active === item
                    ? "text-red-500"
                    : "text-gray-500 hover:text-black"
                }`}
              >
                {item}
              </button>
            ))}

          </div>

        </div>

        {/* Slider Layout */}

        <div className="grid lg:grid-cols-[1fr_2fr_1fr] gap-8 items-center">

          {/* Left */}

          <div className="hidden lg:block">

            <div className="bg-gray-900 rounded-lg overflow-hidden h-[540px] opacity-85">

              <img
                src={portfolio[1].image}
                alt=""
                className="w-full h-full object-cover mix-blend-luminosity"
              />

            </div>

          </div>

          {/* Center */}

          <div className="group">

            <div className="relative overflow-hidden rounded-xl shadow-2xl">

              <img
                src={portfolio[0].image}
                alt=""
                className="w-full h-[650px] object-cover transition duration-700 group-hover:scale-110"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

              <div className="absolute bottom-10 left-10 text-white">

                <h3 className="text-3xl font-bold mb-2">
                  Portrait Session
                </h3>

                <p className="uppercase tracking-widest text-sm">
                  Photography
                </p>

              </div>

            </div>

          </div>

          {/* Right */}

          <div className="hidden lg:block">

            <div className="bg-gray-900 rounded-lg overflow-hidden h-[540px] opacity-85">

              <img
                src={portfolio[2].image}
                alt=""
                className="w-full h-full object-cover mix-blend-luminosity"
              />

            </div>

          </div>

        </div>

      </div>
    </section>
  );
}